var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInquiries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2451 7.82988L15.5101 10.9649C14.8801 13.6724 13.6351 14.7674 11.2951 14.5424C10.9201 14.5124 10.5151 14.4449 10.0801 14.3399L8.82014 14.0399C5.69263 13.2974 4.72513 11.7524 5.46013 8.61738L6.19513 5.47488C6.34513 4.83738 6.52513 4.28238 6.75013 3.82488C7.62763 2.00988 9.12013 1.52238 11.6251 2.11488L12.8776 2.40738C16.0201 3.14238 16.9801 4.69488 16.2451 7.82988Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2938 14.5427C10.8288 14.8577 10.2438 15.1202 9.53129 15.3527L8.34629 15.7427C5.36879 16.7027 3.80129 15.9002 2.83379 12.9227L1.87379 9.9602C0.913791 6.9827 1.70879 5.4077 4.68629 4.4477L5.87129 4.0577C6.17879 3.9602 6.47129 3.8777 6.74879 3.8252C6.52379 4.2827 6.34379 4.8377 6.19379 5.4752L5.45879 8.6177C4.72379 11.7527 5.69129 13.2977 8.81879 14.0402L10.0788 14.3402C10.5138 14.4452 10.9188 14.5127 11.2938 14.5427Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48047 6.39746L13.118 7.31996",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74609 9.2998L10.9211 9.85481",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiries);
export default __webpack_public_path__ + "static/media/inquiries.812c97ab1cd05af5ef01753e3abf7c87.svg";
export { ForwardRef as ReactComponent };